import { createAction } from 'redux-actions';

export const createWatchList = createAction('CREATE_WATCHLIST');
export const createWatchListSuccess = createAction('CREATE_WATCHLIST_SUCCESS');
export const createWatchListFailure = createAction('CREATE_WATCHLIST_FAILURE');

export const deleteWatchList = createAction('DELETE_WATCHLIST');
export const deleteWatchListSuccess = createAction('DELETE_WATCHLIST_SUCCESS');
export const deleteWatchListFailure = createAction('DELETE_WATCHLIST_FAILURE');


export const getSpendingWatchLists = createAction('GET_SPENDING_WATCH_LISTS');
export const getSpendingWatchListsInitial = createAction('GET_SPENDING_WATCH_LISTS_INITIAL')
export const getSpendingWatchListsSuccess = createAction('GET_SPENDING_WATCH_LISTS_SUCCESS');
export const getSpendingWatchListsFailure = createAction('GET_SPENDING_WATCH_LISTS_FAILURE');

export const createSpendingWatchList = createAction('CREATE_SPENDING_WATCH_LIST');
export const createSpendingWatchListSuccess = createAction('CREATE_SPENDING_WATCH_LIST_SUCCESS');
export const createSpendingWatchListFailure = createAction('CREATE_SPENDING_WATCH_LIST_FAILURE');

export const updateSpendingWatchList = createAction('UPDATE_SPENDING_WATCH_LIST');
export const updateSpendingWatchListSuccess = createAction('UPDATE_SPENDING_WATCH_LIST_SUCCESS');
export const updateSpendingWatchListFailure = createAction('UPDATE_SPENDING_WATCH_LIST_FAILURE');

export const deleteSpendingWatchList = createAction('DELETE_SPENDING_WATCH_LIST');
export const deleteSpendingWatchListSuccess = createAction('DELETE_SPENDING_WATCH_LIST_SUCCESS');
export const deleteSpendingWatchListFailure = createAction('DELETE_SPENDING_WATCH_LIST_FAILURE');
